import { IconProps } from './index';

const XSign = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <rect width="36" height="36" rx="18" fill="#ED434B" />
            <path
                d="M18 16.586L22.95 11.636L24.364 13.05L19.414 18L24.364 22.95L22.95 24.364L18 19.414L13.05 24.364L11.636 22.95L16.586 18L11.636 13.05L13.05 11.636L18 16.586Z"
                fill="white"
            />
        </svg>
    );
};

export default XSign;
